import { queryOptions, type UseQueryOptions } from '@tanstack/react-query';
import type {
  GetProfileByUserIdData,
  GetUserProfileResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';
import type { ReplacePathParams } from '@/shared/utils/pathParams';

export interface ProfileKeyParams {
  userId: string;
}

const getProfileUrl = (
  userId: string | number,
): ReplacePathParams<GetProfileByUserIdData['url']> =>
  `profiles/${userId.toString()}`;

export const getProfileKey = ({ userId }: ProfileKeyParams) =>
  ['profiles', userId] as const;

export const getProfileOptions = <T = GetUserProfileResponse>(
  params: ProfileKeyParams,
  options?: Omit<
    UseQueryOptions<GetUserProfileResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >,
) => {
  return queryOptions<GetUserProfileResponse, unknown, T>({
    queryKey: getProfileKey(params),
    queryFn: () =>
      PrivateApi.get(
        getProfileUrl(params.userId),
      ).json<GetUserProfileResponse>(),
    ...options,
  });
};
